export default __webpack_public_path__ + "static/partner10-a9a0a4d381c3ea48fe9c29d30d52df5d.jpg";